import React from 'react';
import {
    Button,
    HorizontalFlex,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'smartsuite-ui';
import PropTypes from 'prop-types';
import { useLabelContext } from '../shared/hooks/labelContext';

export default function EditorErrorModal(props) {
    const { dashboardLabels, translationLabels } = useLabelContext();

    return (
        <Modal onOverlayClick={props.onClose}>
            <ModalHeader onDismiss={props.onClose}>
                <span>{dashboardLabels.invalidDashboardConfiguration}</span>
            </ModalHeader>
            <ModalBody>
                <span>{dashboardLabels.resolveErrors}</span>
            </ModalBody>
            <ModalFooter>
                <HorizontalFlex cssClassModifiers={['justify-flex-end']}>
                    <Button onClick={props.onClose}>
                        {translationLabels.ok}
                    </Button>
                </HorizontalFlex>
            </ModalFooter>
        </Modal>
    );
}

EditorErrorModal.propTypes = {
    onClose: PropTypes.func.isRequired,
};
